import request from '@/router/axios';


///actionTransfer
export const actionTransfer = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/actionTransfer',
        method: 'post',
        data: row
    })
}

//actionTrailer
export const actionTrailer = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/actionTrailer',
        method: 'post',
        data: row
    })
}

//negotiations
export const negotiations = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/negotiations',
        url: '/api/v2/blade-loanPost/loan/negotiations',
        method: 'post',
        data: row
    })
}


//negotiationsTransfer
export const negotiationsTransfer = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/negotiationsTransfer',
        url: '/api/v2/blade-loanPost/loan/negotiationsTransfer',
        method: 'post',
        data: row
    })
}


//violationTransfer
export const violationTransfer = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/violationTransfer',
        url: '/api/v2/blade-loanPost/loan/violationInspectAction',
        method: 'post',
        data: row
    })
}

//violationUpdateViolation
export const violationUpdateViolation = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/violationUpdateViolation',
        url: '/api/v2/blade-loanPost/loan/violationUpdateViolation',
        method: 'post',
        data: row
    })
}

//violationInspectAnnually
export const violationInspectAnnually = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/violationInspectAnnually',
        url: '/api/v2/blade-loanPost/loan/violationInspectAnnually',
        method: 'post',
        data: row
    })
}


//insuranceInsure
export const insuranceInsure = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/insuranceInsure',
        url: '/api/v2/blade-loanPost/loan/insuranceTransfer',
        method: 'post',
        data: row
    })
}

//insuranceTransfer
export const insuranceTransfer = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/insuranceTransfer',
        url: '/api/v2/blade-loanPost/loan/insuranceInsure',
        method: 'post',
        data: row
    })
}

//informationGps
export const informationGps = (loanInformationId) => {
    return request({
        // url: `/api/blade-loanPostOperatorData/loanPostOperatorData/informationGps?loanInformationId=${loanInformationId}`,
        url: `/api/v2/blade-loanPost/loan/informationGps?loanInformationId=${loanInformationId}`,
        method: 'post',
    })
}


//gpsTransfer
export const gpsTransfer = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/gpsTransfer',
        url: '/api/v2/blade-loanPost/loan/gpsTransfer',
        method: 'post',
        data: row
    })
}

//gpsRemark
export const gpsRemark = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/gpsRemark',
        method: 'post',
        data: row
    })
}


//distressedAsset
export const distressedAsset = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/distressedAsset',
        method: 'post',
        data: row
    })
}

//proceedingExecute
export const proceedingExecute = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingExecute',
        url: '/api/blade-legalManagement/legalManagement/dispose',
        method: 'post',
        data: row
    })
}

// 法务管理-刑事处理
export const proceedingTransferCriminalSave = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingTransferCriminalSave',
        url: '/api/blade-legalManagement/legalManagement/criminalDispose',
        method: 'post',
        data: row
    })
}

//proceeding
export const proceeding = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceeding',
        url: '/api/blade-legalManagement/legalManagement/lawsuit',
        method: 'post',
        data: row
    })
}


//settleTransfer
export const settleTransfer = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/settleTransfer',
        url: '/api/v2/blade-loanPost/loan/settleTransfer',
        method: 'post',
        data: row
    })
}



//proceedingTransferNegotiations
export const proceedingTransferNegotiations = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingTransferNegotiations',
        method: 'post',
        data: row
    })
}


//proceedingEntrustThird
export const proceedingEntrustThird = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingEntrustThird',
        url: '/api/blade-legalManagement/legalManagement/entrustAThirdParty',
        method: 'post',
        data: row
    })
}

//proceedingThirdSubmit
export const proceedingThirdSubmit = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingThirdSubmit',
        url: '/api/blade-legalManagement/legalManagement/threeDispose',
        method: 'post',
        data: row
    })
}

//proceedingTransfer
export const proceedingTransfer = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingTransfer',
        url: `/api/blade-legalManagement/legalManagement/turnLawsuit/${row.repaymentPlanId}`,
        method: 'get',
    })
}

//setCarFirstNumber
export const setCarFirstNumber = (row) => {
  return request({
      url: `/api/v2/blade-loanPost/loan/setCarFirstNumber?pageListId=${row.pageListId}&carFirstNumber=${row.carFirstNumber}`,
      method: 'get',
  })
}

//collect-add
export const collectAdd = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/collect-add',
        url: '/api/v2/blade-loanPost/loan/collect-add',
        method: 'post',
        data: row
    })
}



//collect-handover
export const collectHandover = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/collect-handover',
        method: 'post',
        data: row
    })
}


//collector-repayment
export const collectorRepayment = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/collector-repayment',
        method: 'post',
        data: row
    })
}


//collector-update-done-tenancy
export const collectorUpdateDoneTenancy = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/collector-update-done-tenancy',
        method: 'post',
        data: row
    })
}


//settleSubmit
export const settleSubmit = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/settleSubmit',
        url: '/api/v2/blade-loanPost/loan/settleSubmit',
        method: 'post',
        data: row
    })
}


//security-deposit-deduction
export const securityDepositDeduction = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/security-deposit-deduction',
        method: 'post',
        data: row
    })
}

//customer-repayment
export const customerRepayment = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/customer-repayment',
        method: 'post',
        data: row
    })
}

//collector-update-overdue-fine
export const collectorUpdateOverdueFine = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/collector-update-overdue-fine',
        method: 'post',
        data: row
    })
}


// 租后收款
export const treasurerRepaymentReject = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/treasurer-repayment-reject',
        url: '/api/v2/blade-loanPost/loan/treasurer-repayment-reject',
        method: 'post',
        data: row
    })
}

// 谈判收款
export const negotiatingRepaymentReject = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/negotiating-repayment-reject',
      method: 'post',
      data: row
  })
}

// 滞纳金分期收款
export const lateFeeRepaymentReject = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/late-fee-repayment-reject',
      method: 'post',
      data: row
  })
}

//proceedingRemark
export const proceedingRemark = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingRemark',
        url: '/api/v2/blade-loanPost/loan/proceedingRemark',
        method: 'post',
        data: row
    })
}

//proceedingTransferAction
export const proceedingTransferAction = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingTransferAction',
        url: '/api/v2/blade-loanPost/loan/proceedingTransferAction',
        method: 'post',
        data: row
    })
}

//proceedingTransferToSecond
export const proceedingTransferToSecond = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingTransferToSecond',
        url: '/api/blade-legalManagement/legalManagement/twoCareful',
        method: 'post',
        data: row
    })
}

//negotiationsUpdateOverdueFine
export const negotiationsUpdateOverdueFine = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/negotiationsUpdateOverdueFine',
        url: '/api/v2/blade-loanPost/loan/negotiationsUpdateOverdueFine',
        method: 'post',
        data: row
    })
}

//negotiationsUpdateLiquidatedDamagesAmount
export const negotiationsUpdateLiquidatedDamagesAmount = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/negotiationsUpdateLiquidatedDamagesAmount',
        url: '/api/v2/blade-loanPost/loan/negotiationsUpdateLiquidatedDamagesAmount',
        method: 'post',
        data: row
    })
}

export const lawWorksNegotiations = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/legal/negotiations',
      method: 'post',
      data: row
  })
}

////proceedingTransferToCriminal
export const proceedingTransferToCriminal = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/proceedingTransferToCriminal',
        url: '/api/blade-legalManagement/legalManagement/criminal',
        method: 'post',
        data: row
    })
}


export const negotiatePaymentProceeds = (row) => {
    return request({
        url: '/api/blade-negotiate/negotiatePayment/negotiatePaymentProceeds',
        method: 'post',
        data: row
    })
}

export const negotiatePaymentSave = (row) => {
    return request({
        url: '/api/blade-negotiate/negotiatePayment/negotiatePaymentSave',
        method: 'post',
        data: row
    })
}

export const legalNegotiatePaymentSave = (row) => {
  return request({
      url: '/api/blade-negotiate/negotiatePayment/legalNegotiatePaymentSave',
      method: 'post',
      data: row
  })
}

export const cancel = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/cancel',
      method: 'post',
      data: row
  })
}

export const breakFinanceAbandonedPoint = (row) => {
  return request({
      url: '/api/blade-loanInformation/loanInformation/break-finance-abandoned-point',
      method: 'post',
      data: row
  })
}


// 投诉结清收款-确认结算
export const complaintSettleSubmit = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/complain_settlement_settleSubmit',
      method: 'post',
      data: row
  })
}